export default __webpack_public_path__ + "images/12f0f97012b8956a484acfdd52300568.svg";